import { render, staticRenderFns } from "./WeekTemplateDetails.vue?vue&type=template&id=12a46f52&scoped=true&"
import script from "./WeekTemplateDetails.vue?vue&type=script&lang=js&"
export * from "./WeekTemplateDetails.vue?vue&type=script&lang=js&"
import style0 from "./WeekTemplateDetails.vue?vue&type=style&index=0&id=12a46f52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a46f52",
  null
  
)

export default component.exports